module.exports = __webpack_public_path__ + "b1c148052dd170cd6d810472729e778c.svg";